<template>
  <section>
    <h3 class="primary--text"><v-icon info>person_outline</v-icon> {{$t('applicants.title') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :widthModal="800"
        >
          <template slot="items" slot-scope="items">
            <td>{{ items.item.nombres }} {{ items.item.primer_apellido }} {{ items.item.segundo_apellido }}</td>
            <td>{{ items.item.email }}</td>
            <td>{{ items.item.tipo }}</td>
            <td>{{ items.item.tipo_documento }}</td>
            <td>{{ items.item.departamento_nombre }}</td>
            <td>{{ items.item.provincia_nombre }}</td>
            <td>{{ items.item.municipio_nombre }}</td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import Auth from '@/components/admin/auth/mixins/auth';
import validate from '@/common/mixins/validate';
import solicitante from './mixins/solicitante';

export default {
  mixins: [ crud, validate, Auth, solicitante ],
  created () {
    this.user = this.$storage.getUser();
  },
  data () {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'solicitantes',
      headers: [
        { text: this.$t('applicants.crud.names'), value: 'nombres' },
        { text: this.$t('applicants.crud.email'), value: 'email' },
        { text: this.$t('applicants.crud.type_document'), value: 'tipo_documento' },
        { text: this.$t('applicants.crud.type'), value: 'tipo' },
        { text: this.$t('applicants.crud.departament'), value: 'id_departamento' },
        { text: this.$t('applicants.crud.province'), value: 'id_provincia' },
        { text: this.$t('applicants.crud.municipio'), value: 'id_municipio' }
      ],
      dataGraphql: `
        tipo
        nombres
        primer_apellido
        segundo_apellido
        email
        telefono
        fecha_nacimiento
        tipo_documento
        nro_documento
        direccion
        matricula
        id_departamento
        id_provincia
        id_municipio
        departamento_nombre
        provincia_nombre
        municipio_nombre

      `,
      form: {
        'nombres': '',
        'primer_apellido': '',
        'segundo_apellido': ''
      },
      filters: [
        {
          field: 'nombre_completo',
          label: this.$t('applicants.crud.names'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'tipo_documento',
          label: this.$t('applicants.crud.type_document'),
          type: 'select',
          typeG: 'String',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'CI', text: 'CI' },
            { value: 'NIT', text: 'NIT' },
            { value: 'PASAPORTE', text: 'PASAPORTE' }
          ]
        },
        {
          field: 'tipo',
          label: this.$t('applicants.crud.type'),
          type: 'select',
          typeG: 'String',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'NATURAL', text: 'NATURAL' },
            { value: 'JURIDICA', text: 'JURIDICA' }
          ]
        },
        {
          field: 'nro_documento',
          label: this.$t('applicants.crud.number_document'),
          type: 'Integer',
          typeG: 'Int'
        }
      ],
      hidePass: true,
      solicitante: null,
      valid: true
    };
  },
  methods: {
    changeIcon () {
      if (this.form.contrasena.length) {
        this.hidePass = !this.hidePass;
      }
    },
    openModal (data = {}) {
      this.$refs.form.reset();
      if (data.id) {
        this.form = data;
      } else {
        this.form = {
          'nombres': '',
          'primer_apellido': '',
          'segundo_apellido': ''
        };
      }
      this.$store.commit('openModal');
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.id_rol.value) {
          data.id_rol = data.id_rol.value;
        }
        if (data.id_entidad.value) {
          data.id_entidad = data.id_entidad.value;
        }
        if (data.id) {
          delete data.id;
          delete data.entidad_nombre;
          delete data.rol_nombre;
          this.$service.graphql({
            query: `
              mutation edit($id: Int!, $solicitante: EditSolicitante!) {
                solicitanteEdit(id: $id, solicitante: $solicitante) {
                  id
                }
              }
            `,
            variables: {
              id: this.form.id,
              solicitante: data
            }
          }).then(response => {
            if (response) {
              if (this.solicitante === this.form.solicitante) {
                this.$message.warning('Sus datos fueron actualizados, debe ingresar de nuevo al sistema.');
                this.logout();
              } else {
                this.$store.commit('closeModal');
                this.updateList();
                this.$message.success('Se actualizó el registro correctamente');
              }
            }
          });
        } else {
          this.$service.graphql({
            query: `
              mutation add($solicitante: NewSolicitante!) {
                solicitanteAdd(solicitante: $solicitante) {
                  id
                }
              }
            `,
            variables: {
              solicitante: data
            }
          }).then(response => {
            if (response) {
              this.$store.commit('closeModal');
              this.updateList();
              this.$message.success();
            }
          });
        }
      }
    }
  },
  components: {
    CrudTable
  },
  computed: {
    getIcon () {
      return this.form.contrasena.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  }
};
</script>



// WEBPACK FOOTER //
// Solicitante.vue?fd97e380